import { Link } from '../components/widgets/buttons';
import { useDialogManager } from '../components/widgets/dialog';
import React, { FunctionComponent } from 'react';
import ContentLoader from 'react-content-loader';
import { graphql, useLazyLoadQuery } from 'react-relay';
import styled from 'styled-components';
import { docsDialogQuery } from './__generated__/docsDialogQuery.graphql';
import { ConnectShopDialog } from './connectShopDialog';
import theme from './theme';

const DocsContent: FunctionComponent<{ id: string; className?: string }> = (props) => {
    const query = useLazyLoadQuery<docsDialogQuery>(
        graphql`
            query docsDialogQuery($id: ID!) {
                zendeskArticle(id: $id) {
                    title
                    body
                }
            }
        `,
        { id: `guid://Zakeke/ZendeskArticle/${props.id}` }
    );

    return <p className={props.className} dangerouslySetInnerHTML={{ __html: query.zendeskArticle?.body || '' }} />;
};

export const StyledDocsContent = styled(DocsContent)`
    font-family: ${(props) => props.theme.app.font};
    font-size: 16px;

    a {
        color: ${(props) => props.theme.app.component.link};
    }

    img {
        max-width: 100%;
        margin: auto;
        display: block;
    }

    iframe {
        margin: auto;
        display: block;
    }

    .hide-in-the-backoffice {
        display: none;
    }

    .view-in-the-backoffice {
        display: flex !important;
        justify-content: flex-end;
    }
`;

export const Loader = (
    <ContentLoader speed={2} width={'100%'} height='400px' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
        <rect x='2' y='5' rx='10' ry='10' width='100%' height='44' />
        {new Array(20).fill(0).map((x, idx) => (
            <rect key={idx} x='0' y={80 + idx * 30} rx='10' ry='10' width='100%' height='18' />
        ))}
    </ContentLoader>
);

export const ZendeskLink: FunctionComponent<{ dataTrack?: string; linkText: string; title: string; zendeskDocId?: string }> = (props) => {
    const { showDialog } = useDialogManager();

    const onClick = () => {
        if (props.zendeskDocId) {
            showDialog('docs', <ConnectShopDialog title={props.title} id={props.zendeskDocId} />);
        }
    };

    return (
        <Link
            data-track={props.dataTrack}
            onClick={() => {
                onClick();
            }}
        >
            {props.linkText}
        </Link>
    );
};
